import React from "react";

import { MinusCircleFilled, PlusCircleFilled } from "@ant-design/icons";
import { Button } from "antd";

import { checkPinIsPinned } from "../pinHelper";

export default function MapTools({
  handleZoomIn,
  handleZoomOut,
  onZoom,
  refOfWrapper,
  selectedLocationID,
  isAddingNewSwab,
  pinMap,
}) {
  const { minScale, maxScale } = refOfWrapper.current ? refOfWrapper.current.instance.setup : { minScale: null, maxScale: null };
  const { scale } = refOfWrapper.current ? refOfWrapper.current.state : { scale: null };
  // console.log(minScale, maxScale, scale);

  const zoomIn = async () => {
    // console.log(refOfWrapper.current);
    handleZoomIn();
    setTimeout(() => onZoom(refOfWrapper.current), 300);
    // onZoom(refOfWrapper.current);
  };

  const zoomOut = async () => {
    handleZoomOut();
    setTimeout(() => onZoom(refOfWrapper.current), 300);
    // onZoom(refOfWrapper.current);
  };

  /** Disable zoom when user is selecting a quadrant to pin swab in (fixes bug where quadrant overlay overflows the container) */
  const disableZoom = isAddingNewSwab || (selectedLocationID && !checkPinIsPinned(pinMap.get(selectedLocationID)));

  return (
    <div className="tools">
      <Button
        type="default"
        shape="circle"
        onClick={zoomIn}
        disabled={disableZoom || (maxScale && scale && (scale >= maxScale))}
        icon={<PlusCircleFilled />}
      />
      <Button
        type="default"
        shape="circle"
        onClick={zoomOut}
        disabled={disableZoom || (minScale && scale && (scale <= minScale))}
        icon={<MinusCircleFilled />}
      />
    </div>
  );
}
